import styled from "styled-components"
import Card from "../ui/Card"
import ChatWidget from "../widgets/ChatWidget"

const Aside = styled.aside`
  border-right: 1px solid ${(props) => props.theme.border};
  padding: 16px;
  width: 100%;
  
  @media (min-width: 768px) {
    padding: 24px;
    width: 320px;
  }
  
  @media (min-width: 992px) {
    width: 384px;
  }
`

const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
`

const SentimentCard = styled(Card)`
  padding: 16px;
`

const SentimentTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`

const SentimentRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`

const SentimentLabel = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.secondaryText};
`

const SentimentValue = styled.span`
  font-weight: 500;
`

const ProgressBar = styled.div`
  height: 8px;
  background-color: ${(props) => props.theme.secondary};
  border-radius: 9999px;
  overflow: hidden;
`

const ProgressIndicator = styled.div`
  height: 100%;
  width: ${(props) => props.value}%;
  background-color: ${(props) => props.color || props.theme.warning};
`

const TopMoversCard = styled(Card)`
  padding: 16px;
`

const TopMoversTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`

const TopMoversList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const TopMoverItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const CoinInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const CoinIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.primaryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
`

const CoinDetails = styled.div`
  display: flex;
  flex-direction: column;
`

const CoinName = styled.div`
  font-weight: 500;
`

const CoinSymbol = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.secondaryText};
`

const PriceInfo = styled.div`
  text-align: right;
`

const Price = styled.div`
  font-weight: 500;
`

const PriceChange = styled.div`
  font-size: 12px;
  color: ${(props) => (props.positive ? props.theme.success : props.theme.error)};
`

const ViewAllButton = styled.button`
  margin-top: 8px;
  padding: 6px 12px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.border};
  background-color: transparent;
  color: ${(props) => props.theme.text};
  cursor: pointer;
  
  &:hover {
    background-color: ${(props) => props.theme.accent};
  }
`

function DashboardSidebar() {
  const topMovers = [
    { name: "Bitcoin", symbol: "BTC", change: "+5.67%", price: "$43,256.78", positive: true },
    { name: "Ethereum", symbol: "ETH", change: "+3.21%", price: "$2,345.92", positive: true },
    { name: "Ripple", symbol: "XRP", change: "-1.45%", price: "$0.5678", positive: false },
  ]

  return (
    <Aside>
      <SidebarContainer>
        <SentimentCard>
          <SentimentTitle>Market Sentiment</SentimentTitle>
          <SentimentRow>
            <SentimentLabel>Fear & Greed Index</SentimentLabel>
            <SentimentValue>42 - Fear</SentimentValue>
          </SentimentRow>
          <ProgressBar>
            <ProgressIndicator value={42} />
          </ProgressBar>
        </SentimentCard>

        <TopMoversCard>
          <TopMoversTitle>Top Movers</TopMoversTitle>
          <TopMoversList>
            {topMovers.map((coin) => (
              <TopMoverItem key={coin.symbol}>
                <CoinInfo>
                  <CoinIcon>{coin.symbol.charAt(0)}</CoinIcon>
                  <CoinDetails>
                    <CoinName>{coin.name}</CoinName>
                    <CoinSymbol>{coin.symbol}</CoinSymbol>
                  </CoinDetails>
                </CoinInfo>
                <PriceInfo>
                  <Price>{coin.price}</Price>
                  <PriceChange positive={coin.positive}>{coin.change}</PriceChange>
                </PriceInfo>
              </TopMoverItem>
            ))}
          </TopMoversList>
          <ViewAllButton>View All</ViewAllButton>
        </TopMoversCard>

        <ChatWidget />
      </SidebarContainer>
    </Aside>
  )
}

export default DashboardSidebar

